<template>
  <header class="main-header">
    <a class="logo">
      <span class="logo-mini">I</span>
      <span class="logo-lg"><img src="/static/img/logo-interna.png"></span>
    </a>
    <nav class="navbar navbar-static-top" role="navigation">
      <a href="#" class="sidebar-toggle" data-toggle="offcanvas" role="button">
        <span class="sr-only">Toggle navigation</span>
      </a>
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">
          <li>
            <a href="#" title="Sair" @click.prevent="logout()"><i class="fa fa-sign-out"></i> sair</a>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import authentication from '@/services/authentication'

export default {
  name: 'Header',
  data () {
    return {
      projectName: null
    }
  },
  methods: {
    logout () {
      authentication.logout()
      this.$router.push({name: 'Homepage'})
    }
  },
  mounted () {
    this.projectName = this.$config.projectName
  }
}
</script>



// WEBPACK FOOTER //
// Header.vue?70537e02